export default __webpack_public_path__ + "static/media/emptyMessage.0d840c32.png";